import React from 'react'
import { Currency } from '@mobi/utils/money'
import type { KambiValidReward } from '@mobi/api-types/kambi/player/reward'
import type { KambiSportsSelection } from '@mobi/betslip/types'
import { PriceChange } from '@core/Components/Text/utils'
import { calculateKambiSelectionBoostedPriceWithReward } from '@core/Areas/Quickbet/helpers/selectionsKambi'
import { getPriceFromKambiSportsSelection } from '@core/Areas/Quickbet/helpers/selectionsKambi'
import { LegInfoWithPriceComponent } from '../LegInfoWithPriceComponent'

export const KambiSportsLegInfo: React.FC<{
  selection: KambiSportsSelection
  isActive: boolean
  priceChange: PriceChange
  selectedKambiReward: KambiValidReward | null
}> = ({ selection, isActive, priceChange, selectedKambiReward }) => {
  const legInfoLabel =
    selection.betSelectionType === 'single'
      ? 'Single'
      : selection.betSelectionType === 'same-game-multi'
        ? 'Same Game Multi'
        : 'Multi'

  const price = getPriceFromKambiSportsSelection(selection)
  const boostAmount = getBoostAmountForReward(price, selectedKambiReward)

  return (
    <LegInfoWithPriceComponent
      legType={legInfoLabel}
      price={price}
      isActive={isActive}
      boostAmount={boostAmount}
      priceChange={priceChange}
    />
  )
}

// =============
// Local Helpers
// =============

function getBoostAmountForReward(price: number, reward: KambiValidReward | null): number {
  if (!reward) return 0

  const rewardTypesWithBoost: KambiValidReward['rewardType'][] = ['ODDS_BOOST', 'PROFIT_BOOST']
  if (rewardTypesWithBoost.includes(reward.rewardType)) {
    return new Currency(calculateKambiSelectionBoostedPriceWithReward(price, reward)).subtract(
      price
    ).value
  }

  return 0
}
